import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { store } from './model/store';
import { queryClient } from '@client/api/queryClient';
import { BrowserRouter } from 'react-router-dom';
import { Router } from './Router';
import './main.css';
import './styles/globals.css';
import { addLogSender, isRunningUnitTest } from '@shared';
import { clientLogSender } from './util';
import { logRocketInit } from '@shared';
import ScrollToTop from './components/ScrollToTop';
import { IntercomUpdate } from './components';
import { Toaster } from './components/ui/toaster';
import { ConfigurableAuth0Provider } from './components/ConfigurableAuth0Provider';
import { OnboardingTimeTracker } from './components/OnboardingTimeTracker';
import { AppOpenTracker } from './components/AppOpenTracker';
import { FeatureFlagsProvider } from './contexts/FeatureFlagsContext';

logRocketInit();
addLogSender(clientLogSender);

if (!isRunningUnitTest()) {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <ConfigurableAuth0Provider>
              <FeatureFlagsProvider>
                <ScrollToTop />
                <IntercomUpdate />
                <AppOpenTracker />
                <Router />
                <OnboardingTimeTracker />
              </FeatureFlagsProvider>
            </ConfigurableAuth0Provider>
          </BrowserRouter>
        </QueryClientProvider>
      </Provider>
      <Toaster />
    </React.StrictMode>,
  );
}
